import { FieldErrors, FieldPath, FieldValues } from "react-hook-form";
import { TFunction } from "i18next";
export const getErrorMessage = <T extends FieldValues>(
  t: TFunction,
  error: FieldErrors<T>[FieldPath<T>] | undefined,
): string | undefined => {
  if (!error) {
    return undefined;
  }

  if (error.message && typeof error.message === "string") {
    return error.message;
  }

  switch (error.type) {
    case "required": {
      return t("INPUT_FIELD_REQUIRED");
    }
    default: {
      return t("INPUT_FIELD_FALLBACK_ERROR_MESSAGE");
    }
  }
};
